import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function Trio() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const VIDEO_ID = "trio";
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={VIDEO_ID}
      // VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
      // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
      //  VIDEO_ID={GAME_ID}
      // GAME_ID={GAME_ID}
      // shortName={"cards32a cards32b"}
      gameName={"Trio"}
    >
      {/* <div className="center-main-container casino-page"> */}
      {/* <div className="center-container"> */}
      {/* <div className="casino-page-container trio"> */}
      {/* <div className="casino-header">
        <span className="casino-name">
          Trio
          <a className="ms-1">
            <small>Rules</small>
          </a>
        </span>
        <span className="casino-rid d-none d-xl-inline-block">
          <small>
            Round ID: <span>141250501133100</span>
          </small>
        </span>
      </div> */}
      {/* <div className="casino-title-header-mobile d-xl-none">
        <ul className="nav nav-tabs menu-tabs">
          <li className="nav-item">
            <div className="nav-link active">Game</div>
          </li>
          <li className="nav-item">
            <div className="nav-link">Placed Bet (0)</div>
          </li>
        </ul>
        <div className="pe-2">
          <span className="casino-rid">
            Round ID: <span>141250501133100</span>
          </span>
        </div>
      </div> */}
      {/* <div className=""> */}
      {/* <div className="casino-video"> */}
      {/* <div className="video-box-container"> */}
      {/* <div className="casino-video-box"> */}
      {/* <iframe src="/mediaplayer/trio/e7db0b4e-b12b-4be4-81c9-c26ed2e5bb9f?ip=122.160.119.41" /> */}
      {/* </div> */}
      {/* </div> */}
      {/* <div className="casino-video-cards">
            <div className="">
              <div className="flip-card-container">
                <div className="flip-card">
                  <div className="flip-card-inner ">
                    <div className="flip-card-front">
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                    </div>
                    <div className="flip-card-back">
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                    </div>
                  </div>
                </div>
                <div className="flip-card">
                  <div className="flip-card-inner ">
                    <div className="flip-card-front">
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                    </div>
                    <div className="flip-card-back">
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                    </div>
                  </div>
                </div>
                <div className="flip-card">
                  <div className="flip-card-inner ">
                    <div className="flip-card-front">
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                    </div>
                    <div className="flip-card-back">
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
      {/* <div className="clock flip-clock-wrapper">
            <ul className="flip play">
              <li className="flip-clock-before">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">2</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">2</div>
                  </div>
                </a>
              </li>
              <li className="flip-clock-active">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">1</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">1</div>
                  </div>
                </a>
              </li>
            </ul>
            <ul className="flip play">
              <li className="flip-clock-before">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">4</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">4</div>
                  </div>
                </a>
              </li>
              <li className="flip-clock-active">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">3</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">3</div>
                  </div>
                </a>
              </li>
            </ul>
          </div> */}
      {/* </div> */}
      <div className="casino-detail">
        <div className="casino-table">
          <div className="casino-table-box">
            <div className="casino-odd-box-container">
              <div className="casino-nation-name pointer">
                Session <i className="fas fa-info-circle" />
              </div>
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Session", casinoData, dispatch, "back")}
              >
                <span className="casino-odds">
                  {" "}
                  {getOddForEntity("Session", casinoData, true)}
                </span>
                <span className="casino-volume">
                  {getOddForEntity("Session", casinoData, true, true)}
                </span>
              </div>
              {/* <div className="casino-odds-box lay"> */}
              <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Session", casinoData, dispatch, "lay")}
              >
                <span className="casino-odds">
                  {getOddForEntity("Session", casinoData, false)}
                </span>
                <span className="casino-volume">
                  {getOddForEntity("Session", casinoData, false, true)}
                </span>
              </div>
              {/* <div className="casino-nation-book text-center w-100" /> */}
              <p className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Session")}
              </p>
            </div>
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">3 Card Judgement(1 2 4)</div>
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet(
                    "3 Card Judgement(1 2 4)",
                    casinoData,
                    dispatch,
                    "back"
                  )
                }
              >
                <span className="casino-odds">
                  {getOddForEntity("3 Card Judgement(1 2 4)", casinoData, true)}
                </span>
              </div>
              {/* <div className="casino-odds-box lay"> */}
              <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet("3 Card Judgement(1 2 4)", casinoData, dispatch, "lay")
                }
              >
                <span className="casino-odds">
                  {getOddForEntity(
                    "3 Card Judgement(1 2 4)",
                    casinoData,
                    false
                  )}
                </span>
              </div>
              {/* <div className="casino-nation-book text-center w-100" /> */}
              <p className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(
                  casinoPlData,
                  "3 Card Judgement(1 2 4)"
                )}
              </p>
            </div>
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">3 Card Judgement(J Q K)</div>
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet(
                    "3 Card Judgement(J Q K)",
                    casinoData,
                    dispatch,
                    "back"
                  )
                }
              >
                <span className="casino-odds">
                  {getOddForEntity("3 Card Judgement(J Q K)", casinoData, true)}
                </span>
              </div>
              {/* <div className="casino-odds-box lay"> */}
              <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet("3 Card Judgement(J Q K)", casinoData, dispatch, "lay")
                }
              >
                <span className="casino-odds">
                  {getOddForEntity(
                    "3 Card Judgement(J Q K)",
                    casinoData,
                    false
                  )}
                </span>
              </div>
              {/* <div className="casino-nation-book text-center w-100" /> */}
              <p className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(
                  casinoPlData,
                  "3 Card Judgement(J Q K)"
                )}
              </p>
            </div>
          </div>
          <div className="casino-table-box triocards mt-3">
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">Two Red Only</div>
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet("Two Red Only", casinoData, dispatch, "back")
                }
              >
                <span className="casino-odds">
                  {getOddForEntity("Two Red Only", casinoData, true)}
                </span>
              </div>
              {/* <div className="casino-odds-box lay"> */}
              <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet("Two Red Only", casinoData, dispatch, "lay")
                }
              >
                <span className="casino-odds">
                  {getOddForEntity("Two Red Only", casinoData, false)}
                </span>
              </div>
              {/* <div className="casino-nation-book text-center w-100" /> */}
              <p className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Two Red Only")}
              </p>
            </div>
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">Two Black Only</div>
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet("Two Black Only", casinoData, dispatch, "back")
                }
              >
                <span className="casino-odds">
                  {getOddForEntity("Two Black Only", casinoData, true)}
                </span>
              </div>
              {/* <div className="casino-odds-box lay"> */}
              <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet("Two Black Only", casinoData, dispatch, "lay")
                }
              >
                <span className="casino-odds">
                  {getOddForEntity("Two Black Only", casinoData, false)}
                </span>
              </div>
              {/* <div className="casino-nation-book text-center w-100" /> */}
              <p className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Two Black Only")}
              </p>
            </div>
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">Two Odd Only</div>
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet("Two Odd Only", casinoData, dispatch, "back")
                }
              >
                <span className="casino-odds">
                  {getOddForEntity("Two Odd Only", casinoData, true)}
                </span>
              </div>
              {/* <div className="casino-odds-box lay"> */}
              <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet("Two Odd Only", casinoData, dispatch, "lay")
                }
              >
                <span className="casino-odds">
                  {getOddForEntity("Two Odd Only", casinoData, false)}
                </span>
              </div>
              {/* <div className="casino-nation-book text-center w-100" /> */}
              <p className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Two Odd Only")}
              </p>
            </div>
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">Two Even Only</div>
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet("Two Even Only", casinoData, dispatch, "back")
                }
              >
                <span className="casino-odds">
                  {getOddForEntity("Two Even Only", casinoData, true)}
                </span>
              </div>
              {/* <div className="casino-odds-box lay"> */}
              <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet("Two Even Only", casinoData, dispatch, "lay")
                }
              >
                <span className="casino-odds">
                  {getOddForEntity("Two Even Only", casinoData, false)}
                </span>
              </div>
              {/* <div className="casino-nation-book text-center w-100" /> */}
              <p className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Two Even Only")}
              </p>
            </div>
          </div>
          <div className="casino-table-box trioodds mt-3">
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">Pair</div>
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Pair", casinoData, dispatch, "back")}
              >
                <span className="casino-odds">
                  {getOddForEntity("Pair", casinoData, true)}
                </span>
              </div>
              {/* <div className="casino-nation-book text-center w-100" /> */}
              <p className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Pair")}
              </p>
            </div>
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">Flush</div>
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Flush", casinoData, dispatch, "back")}
              >
                <span className="casino-odds">
                  {getOddForEntity("Flush", casinoData, true)}
                </span>
              </div>
              {/* <div className="casino-nation-book text-center w-100" /> */}
              <p className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Flush")}
              </p>
            </div>
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">Straight</div>
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Straight", casinoData, dispatch, "back")}
              >
                <span className="casino-odds">
                  {getOddForEntity("Straight", casinoData, true)}
                </span>
              </div>
              {/* <div className="casino-nation-book text-center w-100" /> */}
              <p className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Straight")}
              </p>
            </div>
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">Trio</div>
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Trio", casinoData, dispatch, "back")}
              >
                <span className="casino-odds">
                  {getOddForEntity("Trio", casinoData, true)}
                </span>
              </div>
              {/* <div className="casino-nation-book text-center w-100" /> */}
              <p className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Trio")}
              </p>
            </div>
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">Straight Flush</div>
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet("Straight Flush", casinoData, dispatch, "back")
                }
              >
                <span className="casino-odds">
                  {getOddForEntity("Straight Flush", casinoData, true)}
                </span>
              </div>
              {/* <div className="casino-nation-book text-center w-100" /> */}
              <p className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Straight Flush")}
              </p>
            </div>
          </div>
        </div>
        {/* <div className="casino-last-result-title">
            <span>Last Result</span>
            <span>
              <a href="/casino-results/trio">View All</a>
            </span>
          </div>
          <div className="casino-last-results">
            <span className="result result-b">R</span>
            <span className="result result-b">R</span>
            <span className="result result-b">R</span>
            <span className="result result-b">R</span>
            <span className="result result-b">R</span>
            <span className="result result-b">R</span>
            <span className="result result-b">R</span>
            <span className="result result-b">R</span>
            <span className="result result-b">R</span>
            <span className="result result-b">R</span>
          </div> */}
      </div>
      {/* </div> */}
      <div className="d-none">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
      {/* <div className="sidebar right-sidebar casino-right-sidebar">
    <div className="sidebar-box my-bet-container">
      <div className="sidebar-title">
        <h4>My Bet</h4>
      </div>
      <div className="my-bets">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
    </div>
  </div> */}
      {/* </div> */}
    </CasinoPage>
  );
}
